import styled from "styled-components";

const DefaultMaxScreenSize              = "575px";
const DefaultWidgetHeaderBgColor        = "#428cc0";
const DefaultWidgetHeaderIconColor      = "#ffffff";

export const WidgetHeaderContainer      = styled.div`
    position: fixed;
    left: 0;
    top: 0;
    background-color: ${(DefaultWidgetHeaderBgColor)};
    width: 100%;
    height: 31px;
    opacity: unset;

    color: white;
    //z-index: 10;
    z-index: 15;

    @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
        height: 40px;
        transition: 0.3s ease-in-out;
    }
`;
export const WidgetHeaderBox            = styled.div`
    background-color: transparent;
    width: 100%;
    top:0;
    margin: auto;
    bottom:auto;

    height: 100%;

    display: inline-flex;
    justify-content: space-between;
`;
export const WidgetHeader               = styled.div`
    background-color: transparent;
    display: flex;
`;
export const WidgetHeaderController     = styled.div`
    background-color: ${(DefaultWidgetHeaderIconColor)};
    cursor: pointer;
    background-color: transparent;

    display: flex;
    align-items: center;
    justify-items: center;
    justify-content: center;

    padding-left: 1px;
    padding-right: 1px;
`;

export const ControllerBtnIconLarge     = styled.div`
    display: none;
    
    @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
        display: flex;
        align-items: center;
        transition: 0.3s ease-in-out;
    }        
`;
export const ControllerBtnIcon          = styled.div`
    display: flex;
    align-items: center;

    @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
        display: none;
        transition: 0.3s ease-in-out;
    } 
`;
export const ControllerBtnIconFixed     = styled.div`
    display: flex;
`;